import {FC} from "react";
import {useTranslation} from "react-i18next";
import {
  SimpleTable,
  TableBody,
  TableCell,
  TableRow
} from "@interstate/components/SimpleTable";
import {TabRow} from "../../../../../tab-content";

export interface TelecomNumbersRowProps {
  telecomNumbers?: string[];
}

export const TelecomNumbersRow: FC<TelecomNumbersRowProps> = ({
  telecomNumbers
}) => {
  const {t} = useTranslation();
  return (
    <TabRow
      name={"telecom-numbers"}
      header={<h4>{t("entity-detail.dealer.phone")}</h4>}>
      <SimpleTable
        id={"telecom-numbers-table"}
        data-testid={"telecom-numbers-table"}
        dataDensity={"small"}
        background={"white"}
        className={"telecom-numbers-table"}
        bordered={false}
        hover={false}
        striped={false}>
        <TableBody
          id={"telecom-numbers-table-body"}
          data-testid={"telecom-numbers-table-body"}
          className={"telecom-numbers-table-body telecom-numbers-body"}>
          <TableRow className={"telecom-numbers-row"}>
            <TableCell
              id={"telecom-numbers-label"}
              data-testid={"telecom-numbers-label"}
              className={"telecom-numbers-label"}>
              {t("entity-detail.dealer.phone")}
            </TableCell>
            <TableCell
              id={"telecom-numbers-value"}
              data-testid={"telecom-numbers-value"}
              className={"telecom-numbers-value"}>
              <ul className={"phone-numbers"}>
                {telecomNumbers?.map((phone: string) => (
                  <li key={phone} className={"phone-number"}>
                    {phone}
                  </li>
                ))}
              </ul>
            </TableCell>
          </TableRow>
        </TableBody>
      </SimpleTable>
    </TabRow>
  );
};
